import * as React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import hoistStatics from 'hoist-non-react-statics';

import EventTracking, { getEventProperties } from 'lib/EventTracking';

function trackView<Props extends {}>(
  Component: React.ComponentType<Props>,
  eventScreenName?: string | null,
  getEventPropertiesFromProps?: (props: any) => any
) {
  class WrappedComponent extends React.Component<Props> {
    static contextTypes = {
      eventProperties: PropTypes.object,
    };

    // $FlowIssue property `displayName`. Property not found
    displayName = `TrackView(${Component.displayName})`;

    componentDidMount() {
      // $FlowIssue property `displayName`. Property not found
      const screenName = eventScreenName || Component.displayName;
      invariant(
        screenName,
        'TriggerViewEvent requires an eventScreenName, otherwise it would be the same as the automatically generated view event.'
      );

      const eventPropertiesFromProps = getEventPropertiesFromProps
        ? getEventPropertiesFromProps(this.props)
        : {};
      const viewProperties = getEventProperties(eventPropertiesFromProps, this.context);
      EventTracking.view(screenName, viewProperties);
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  return hoistStatics(WrappedComponent, Component);
}

export default trackView;
